import LazyLoader from "../../Progress/LazyLoader";
import { useUserData } from "src/context/userContext";
import { lazy } from "react";
const KeikkaSelectorSearch = lazy(() =>
  import("src/data/keikka/KeikkaSelectorSearch/KeikkaSelectorSearch")
);

export default function SiteAppBarSearch() {
  const { ownerAsiakasId } = useUserData();

  return (
    <div className="onlyWide">
      <LazyLoader>
        <div style={{ paddingLeft: 8 }}>
          <KeikkaSelectorSearch
            autoNavigate={true}
            showEditButton={false}
            size="small"
            label="Hae tilausta"
            ownerAsiakasId={ownerAsiakasId}
          />
        </div>
      </LazyLoader>
    </div>
  );
}
